module.exports = __webpack_public_path__ + "static/media/lea.1e256244.png";